import { Component, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Select, Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { PaymentMethod } from 'src/app/core/models';
import { PaymentMethodsState } from 'src/app/core/store/payment-methods/payment-methods.state';

@Component({
  selector: 'app-payment',
  templateUrl: './payment.component.html',
  styleUrls: ['./payment.component.scss'],
})
export class PaymentComponent implements OnInit {
  @Select(PaymentMethodsState.paymentMethods) paymentMethods$!: Observable<PaymentMethod[]>;
  @Select(PaymentMethodsState.defaultPaymentMethod) defaultPaymentMethod$!: Observable<PaymentMethod | null>;

  paymentMethodControl: FormControl = new FormControl(null);
  displayNewPaymentMethodModal: boolean = false;

  constructor(private store: Store) {}

  ngOnInit(): void {
    this.defaultPaymentMethod$.subscribe((defaultPaymentMethod: PaymentMethod | null) => {
      if (defaultPaymentMethod && !this.paymentMethodControl.value) {
        this.paymentMethodControl.setValue(defaultPaymentMethod.id);
      }
    });
  }

  showNewPaymentMethodModal() {
    this.displayNewPaymentMethodModal = true;
  }

  onPaymentMethodCreated(newPaymentMethodId: string) {
    this.paymentMethodControl.setValue(newPaymentMethodId);
  }
}
